import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

const EdlevoActivities = () => {
    const { t } = useTranslation(['help']);

    return (
        <div>
            <h1>{t('edlevoActivities.title', { ns: 'help' })}</h1>
            <p>{t('edlevoActivities.text1', { ns: 'help' })}</p>
            <h3>{t('edlevoActivities.activityBaseAdjustment.title', { ns: 'help' })}</h3>
            <p>{t('edlevoActivities.activityBaseAdjustment.text1', { ns: 'help' })}</p>
            <p>{t('edlevoActivities.activityBaseAdjustment.text2', { ns: 'help' })}</p>
            <p>{t('edlevoActivities.activityBaseAdjustment.text3', { ns: 'help' })}</p>
            <h3>{t('edlevoActivities.groupBasedReader.title', { ns: 'help' })}</h3>
            <p>{t('edlevoActivities.groupBasedReader.text1', { ns: 'help' })}</p>
            <img src="./help-images/Gruppbaserad.png"/>
            <h3>{t('edlevoActivities.activityBasedReader.title', { ns: 'help' })}</h3>
            <p>{t('edlevoActivities.activityBasedReader.text1', { ns: 'help' })}</p>
            <img src="./help-images/Aktivitetsbaserad.png"/>
            <p><Trans i18nKey='edlevoActivities.activityBasedReader.text2' ns='help'/></p>
        </div>
    )
}

export default EdlevoActivities;
